import script from "./PanelInboundAddResult.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelInboundAddResult.vue?vue&type=script&setup=true&lang=js"

import "./PanelInboundAddResult.vue?vue&type=style&index=0&id=b47c58f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b47c58f0"]])

export default __exports__